export default __webpack_public_path__ + "static/media/cart3hover.14cae33c.jpg";